import { CourtState } from "../../types";
import {
  CREATE_COURT_SUCCESS,
  DELETE_COURT_SUCCESS,
  EDIT_COURT_SUCCESS,
  FETCH_ALL_COURTS_SUCCESS,
  FETCH_AVAILABLE_COURTS_SUCCESS,
  LOGOUT_USER_REQUEST
} from "../constants";

const initialState: CourtState = {
  courts: [],
};

// eslint-disable-next-line
export default (state = initialState, action: any): any => {
  switch (action.type) {
    case CREATE_COURT_SUCCESS:
      return {
        ...state,
        courts: [...state.courts, action.payload.newCourt],
      };
    case FETCH_ALL_COURTS_SUCCESS:
      return {
        ...state,
        courts: action.payload.allCourts,
      };
    case EDIT_COURT_SUCCESS:
      return {
        ...state,
        courts: action.payload.allCourts,
      };
    case DELETE_COURT_SUCCESS:
      return {
        ...state,
        courts: action.payload.allCourts,
      };
    case FETCH_AVAILABLE_COURTS_SUCCESS:
      return {
        ...state,
        courts: action.payload.allCourts,
      };
    case LOGOUT_USER_REQUEST:
      return initialState;
    default:
      return state;
  }
};
